import {
  $delete, $request, $post, $put, $get,
} from '@/utils/request';
import servers from '../servers';

type DeleteById = {
  id?: number
}

/**
 * @description: 空间字典 - 全量S6设备及对应S5导出
 */
export const exportSpaceAndEquipRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.dmpOpenAPI}/api/v1/sensor/equipmentExport`,
  method: 'post',
  data,
});

/**
 * @description: 空间字典导入URL
 */
export const uploadSpaceDictionaryUrl = `${servers.base}/api/v1/space/spaceEquipDict/importSpaceDictExcelVo`;

/**
 * @description: 获取当前空间树信息
 */
export const getSpaceInfoRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spaceInfo/tree`, data);

/**
 * @description: 获取蓝海空间数据
 */
export const get3DConfigRequest = () => $get(`${servers.base}/api/v1/space/spaceInfo/get3DConfig`);
/**
 * @description: 空间信息新增
 */
export const setSpaceInfoRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spaceInfo/insert`, data);

/**
 * @description: 空间信息修改
 */
export const updateSpaceInfoRequest = (data = {}) => $put(`${servers.base}/api/v1/space/spaceInfo/update`, data);

/**
 * @description: 空间信息删除
 */
export const deleteSpaceInfoRequest = (data: DeleteById = {}) => $delete(
  `${servers.base}/api/v1/space/spaceInfo/delete?id=${data.id}`
);

/**
 * @description: 空间树导入
 */
export const importExcelUrl = `${servers.base}/api/v1/space/spaceInfo/importExcel2`;
// export const importExcelUrl = `${servers.base}/api/v1/space/spaceInfo/importExcel`;

/**
 * @description: 空间版本列表
 */
export const getSpaceVersionRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spaceVersion/list`,
  method: 'get',
  params,
});

/**
 * @description: 空间版本新增
 */
export const setSpaceVersionRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spaceVersion/insert`, data);

/**
 * @description: 空间版本复制
 */
export const copySpaceVersionRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spaceVersion/copy`, data);

/**
 * @description: 空间版本修改
 */
export const updateSpaceVersionRequest = (data = {}) => $put(`${servers.base}/api/v1/space/spaceVersion/update`, data);

/**
 * @description: 空间版本发布
 */
export const publishSpaceVersionRequest = (data = {}) => $put(
  `${servers.base}/api/v1/space/spaceVersion/publish`, data
);

/**
 * @description: 空间版本删除
 */
export const deleteSpaceVersionRequest = (data: DeleteById = {}) => $delete(
  `${servers.base}/api/v1/space/spaceVersion/delete?id=${data?.id}`
);

/**
 * @description: 查询空间设备字典信息
 */
export const getSpaceEquipDictRequest = () => $get(`${servers.base}/api/v1/space/spaceEquipDict/mapSpaceEquipDict`);

/**
 * @description: 通过空间编码获取设备信息
 */
export const getDeviceInfoBySpaceCodeRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/equip/getBySpaceCodeVo`,
  method: 'get',
  params,
});

/**
 * @description: 绑定设备
 */
export const bindDeviceRequest = (data = {}) => $post(`${servers.base}/api/v1/space/equip/bindVo`, data);

/**
 * @description: 解绑设备
 */
export const unbindDeviceRequest = (data: DeleteById) => $delete(
  `${servers.base}/api/v1/space/equip/unbindVo?spaceCode=${data.id}`
);

/**
 * @description: 查询设备点位信息列表
 */
export const getEquipPointListRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spacePoint/listSpacePointVo`,
  method: 'get',
  params,
});

/**
 * @description: 新增设备点位信息
 */
export const insertEquipPointRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spacePoint/insertVo`, data);

/**
 * @description: 修改设备点位信息
 */
export const updateEquipPointRequest = (data = {}) => $put(`${servers.base}/api/v1/space/spacePoint/updateVo`, data);

/**
 * @description: 删除设备点位信息
 */
export const deleteEquipPointRequest = (data: DeleteById = {}) => $delete(
  `${servers.base}/api/v1/space/spacePoint/deleteVo?id=${data.id}`
);

/**
 * @description: 根据空间层级获取具体层级的数据
 */
export const getSpaceListRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spaceInfo/listFrontSelect`, data);

/**
 * @description: 空间版本复制
 */
// eslint-disable-next-line max-len
export const saveOneIdBySpaceListVo = (data = {}) => $post(`${servers.base}/api/v1/space/spaceInfo/saveOneIdBySpaceListVo`, data);

/**
 * @description: 同步项目空间信息
 */
export const syncAirSpaceInfoByProjectCardRequest = (data = {}) => $post(
  `${servers.base}/api/v1/space/spaceInfo/syncSpaceInfo`,
  data
);

/**
 * @description: 设备台账分页查询
 */
export const getSpaceEquipPageRequest = (data = {}) => $post(`${servers.base}/api/v1/space/spaceInfo/equipPage`, data);
